<template>
  <div class="study-box">
    <div class="content view-box" v-if="videoDetail">
      <Video :src="videoDetail.video" :img="videoDetail.image" @play="playVideo"/>
      <div class="title">
        <p>{{videoDetail.title}}</p>
        <div><img style="width:18px;height:18px" src="../../assets/img/study/icon_eye_grey.png" alt="">{{getNum('viewNum')}}</div>
      </div>
      <ul class="tag" v-if="!videoDetail.module">
        <li v-for="tag in tags" :key="tag.typeId">{{tag.typeName}}</li>
      </ul>
      <div class="share" v-if="!videoDetail.module">
        <span>分享人</span>
        <div class="share-plaza">{{videoDetail.plazaName}}</div>
        <div class="share-brand">{{videoDetail.brandName}}</div>
      </div>
      <div class="project">
        <div class="info">
          <span>{{getNum('playNum')}}播放</span>
          <span>{{videoDetail.shelvesTime.slice(0, 10)}}</span>
        </div>
        <div class="about">
          <span>简介</span>
          <p>
            {{videoDetail.content}}
          </p>
        </div>
      </div>
    </div>
    <div v-show="!videoDetail && !isLoading" class="no-resource">
      <img width="250" height="196" src="../../assets/img/common/noResource.png" alt="">
      暂无视频内容
    </div>
  </div>
</template>

<script>
import { getVideoDetail, putPlayNum } from '@/api/study'
export default {
  name: 'Study',

  mixins: [],

  components: { Video: () => import('@/components/Video') },

  props: {},

  data() {
    return {
      id: '',
      videoDetail: null,
      hasPlayed: false,
      isLoading: false
    };
  },

  computed: {
    tags() {
      if(this.videoDetail && this.videoDetail.types) {
        let typesArr = JSON.parse(this.videoDetail.types.replace(/'/g, '"'))
        if(typesArr && typesArr.length > 0) {
        //   let typeStr = []
        //   typesArr.forEach(ele => {
        //     typeStr.push(ele.typeName)
        //   });
        //   return typeStr.slice(0, -1)
          return typesArr
        }else return []
      }else return []
    },
  },

  watch: {},

  created() {
    if(this.$route.query.type == '1') {
      document.title = '操作手册'
    }
    this.initData()
  },

  mounted() {},

  destroyed() {},

  methods: {
    async initData() {
      this.isLoading = true
      this.id = this.$route.query.studyId;
      this.videoDetail = await getVideoDetail(this.id).catch(() => {
        this.isLoading = false
      })
      this.isLoading = false
      this.$bsUtils.nativeApi.sendMessageToNative({
        videoTitle: this.videoDetail.title
      })
    },
    async playVideo() {
      if(this.hasPlayed) return
      await putPlayNum(this.id)
      this.$bsUtils.nativeApi.sendMessageToNative({
        playCount: this.videoDetail.viewNum
      })
      this.hasPlayed = true
    },
    getNum(numberType) {
      if(this.videoDetail) {
        if(!this.videoDetail[numberType] && this.videoDetail[numberType]  != 0) return '--'
        if(this.videoDetail[numberType] < 10000) {
          return this.videoDetail[numberType]
        }else if(this.videoDetail[numberType] < 100000000) {
          let num = (this.videoDetail[numberType] / 10000).toFixed(1)
          if(num[num.length - 1] == '0') {
            return num.slice(0, -2) + '万'
          }else return num + '万'
        }else {
          return (this.videoDetail[numberType] / 100000000).toFixed(0) + '亿'
        }
      }else return '--'
    }
  },
};
</script>

<style lang="less" scoped>
.study-box {
  width: 100%;
  height: 100%;
  background: #f4f4f4;
  padding: 20px 10px;
  box-sizing: border-box;
}
.no-resource {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #999999;
  width: 100%;
  height: 100%;
  padding: 127px 0 0;
}
.content {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  .title {
    width: 100%;
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
    p {
      width: 75%;
      font-size: 16px;
      font-weight: bold;
      line-height: 22px;
      color: #333333;
      word-wrap: break-word;
      margin: 0 10px 0 0;
      text-align: left;
    }
    div {
      display: flex;
      font-size: 14px;
      line-height: 18px;
      img {
        margin-right: 4px;
      }
    }
  }
  .tag {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 8px;
    li {
      padding: 4px 10px;
      line-height: 16px;
      font-size: 12px;
      margin-bottom: 5px;
      background: #FF6F00;
      opacity: 0.1;
      color: #FF6F00;
      border-radius: 50px;
      &:not(:last-child){
        margin-right: 8px;
      }
    }
  }
  .share {
    text-align: left;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    margin: 7px 0 12px;
    span {
      color: #999999;
    }
    .share-plaza {
      margin-left: 8px;
      margin-right: 2px;
      color: #666666;
    }
  }
  .project {
    width: 100%;
    .info {
      display: flex;
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 12px;
      color: #999999;
      justify-content: space-between;
    }
    .about {
      display: flex;
      flex-direction: column;
      width: 100%;
      text-align: left;
      line-height: initial;
      span {
        font-size: 14px;
        color: #999999;
        margin-bottom: 8px;
      }
      p {
        color: #666666;
        word-wrap: break-word;
        font-size: 14px;
        margin: 0;
      }
    }
  }
}
</style>
